// icon
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
// style
import style from './head.module.css';

const Head = ({ url }) => {
  return (
    <div className={style.head}>
      <div className="container">
        <Link to={url} className={style.link}>
          <FaArrowLeft className={style.icon} /> <span>назад</span>
        </Link>
      </div>
    </div>
  );
};
export default Head;
